<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6 h6">{{ new Date().getFullYear() }} © Namirembe Diocese Young Sacco.</div>
        <div class="col-sm-6 h6 text-end">Next Subscription Date: <span class="text-primary">{{ expiredate }} </span> | <span class="text-danger"> {{ days }}</span></div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      expiredate: localStorage.getItem("license"),
    };
  },
  computed: {
    days() {
      const today = new Date()
      const expires = new Date(this.expiredate)
      const difference = expires.getTime() - today.getTime()
      const left = Math.floor(difference / (1000 * 60 * 60 * 24))
      return left + ' days'
    },
  },
};
</script>